<template>
  <div class="content">
    <img src="@/assets/images/loadBank.png" class="bg_img" alt="" />
    <img
      src="@/assets/images/loadCom.png"
      class="bg_com"
      alt=""
      mode="widthFix"
    />
    <div class="load_info">
      <p class="title">开放云书院</p>
      <p class="info">扫描二维码下载开放云书院客户端</p>
      <div class="info_box">
        <div class="left_list">
          <div
            v-for="(item, index) in loadList"
            :key="index"
            @click="changeImg(item.id)"
          >
            <img :src="item.img" alt="" />
            <p
              @mouseenter="handleEnter(item.id)"
              @mouseleave="handleLeave(item.id)"
            >
              {{ item.name }}
            </p>
          </div>
        </div>
        <div class="weixin_nr" v-if="show">
          <div class="arrow"></div>
          <img src="@/assets/images/idCode1.png" width="200" height="200" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OuchnOss } from "@/plugins/OuchnOss";
import { apiselectConfig } from "@/api/user/profile";
export default {
  data() {
    return {
      ouchnoss1: null,
      downloadLink: null,
      appName: null,
      show: false,
      loadList: [
        {
          img: require("@/assets/images/windows-fill.png"),
          name: "PC端下载",
          id: 1,
        },
        {
          img: require("@/assets/images/ios.png"),
          name: "IOS/安卓下载",
          id: 2,
        },
      ],
      loadState: 0, //1:pc  2:ios  3:安卓
    };
  },
  created() {
    this.ouchnoss1 = new OuchnOss(true);
    this.selectConfig();
  },
  methods: {
    // 鼠标移入
    handleEnter(e) {
      if (e == 2) {
        this.show = true;
      }
    },
    // 鼠标移出
    handleLeave(e) {
      if (e == 2) {
        this.show = false;
      }
    },
    selectConfig() {
      apiselectConfig().then((res) => {
        this.downloadLink = res.data.downloadLink;
        this.appName = res.data.appName;
      });
    },
    changeImg(e) {
      this.loadState = e;
      if (e == 1) {
        if (this.downloadLink) {
          this.ouchnoss1.downloadByUrl(this.downloadLink, this.appName);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.bg_img {
  position: absolute;
  width: 100%;
  height: 83%;
}
.bg_com {
  z-index: 10;
  position: absolute;
  width: 80%;
  top: 18%;
  left: 2%;
}
.load_info {
  position: absolute;
  width: 50%;
  height: 800px;
  right: 0;
  top: 30%;
  z-index: 200;
  .title,
  .info {
    font-family: AdobeHeitiStd-Regular;
    font-size: 84px;
    color: #ffffff;
  }
  .info {
    font-size: 36px;
  }
  .info_box {
    width: 676px;
    height: 400px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left_list {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      height: 60%;
      div {
        cursor: pointer;
        width: 380px;
        height: 80px;
        background-color: #0088f2;
        box-shadow: 0px 5px 2px 0px rgba(30, 72, 214, 0.34);
        border-radius: 14px;
        border: solid 1px #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
        p {
          font-family: PingFangSC;
          font-size: 40px;
          font-weight: 400;
          color: #ffffff;
        }
        img {
          margin: 0 28px 0 -28px;
          width: 25px;
          height: 25px;
        }
      }
    }
    .img_box {
      width: 214px;
      height: 214px;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;

      img {
        margin: 0 auto;
        width: 186px;
        height: 186px;
      }
    }
  }
}
.weixin_nr {
  width: 200px;
  height: 200px;
  text-align: center;
  position: absolute;
  left: 500px;
  top: 25px;
  img {
    margin: 0 auto;
    width: 200px;
    height: 200px;
  }
  .arrow {
    height: 0px;
    width: 0px;
    border-top: 10px solid #fff;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    position: absolute;
    left: 90px;
    top: 200px;
  }
}
</style>